import { Component, OnInit } from '@angular/core';
import {NavigationService} from '../../services/nav/navigation.service';
import { AccountActionsComponent } from '../account-actions/account-actions.component';
import { NotFoundComponent } from '../../not-found/not-found.component';
import { UtButtonComponent } from '../../ui';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-public-not-found',
    templateUrl: './public-not-found.component.html',
    styleUrls: ['./public-not-found.component.scss'],
    imports: [AccountActionsComponent, NotFoundComponent, UtButtonComponent, TranslatePipe]
})
export class PublicNotFoundComponent implements OnInit {

  constructor(public nav: NavigationService) { }

  ngOnInit(): void {
  }

}
